import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './PtinRequiredView.sass'
import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import { useBrandingSettings } from 'hooks/branding'
import { getYear } from '../../utils/date-util'
import Button from '../Button'

export default observer(function PtinRequiredView() {
  const { corporateMode } = useBrandingSettings()

  return (
    <div className={cx(styles.root)}>
      <div className={styles.box}>
        <EmptyState
          pad
          animate
          title={'New year, new PTIN required!'}
          subtitle={`Renew your PTIN to unlock this page. Without your updated ${getYear()} PTIN, you won't be able to pick up or work on any jobs. Upon submission it might take up to 48 hours to regain access.`}
          hideIllustration={corporateMode}
          image={
            <div className={styles.image}>
              <EmptyStateIllustrationImage
                src={require('assets/images/img_id.svg')}
              />
            </div>
          }
        >
          <Button
            type={'primary'}
            href={
              'https://www.taxfyle.com/ptin-renewal?_hsenc=p2ANqtz-9iQqtGsdr7HzhgQqiJ0a0dyg1A9SypjOzkKSELh50CLEJKBCrrKgJfVF5xnP6dYnO91wyB'
            }
            target={'_blank'}
          >
            Update My Credentials
          </Button>
        </EmptyState>
      </div>
    </div>
  )
})
